import React from "react";
import CheckBox from "../../../../CheckBox/CheckBox";

const AdvancedElectroMuscular = ({
  advancedElectroMuscularData,
  setAdvancedElectroMuscularData,
}) => {
  return (
    <div className="overflow-x-auto md:overflow-x-visible rounded-xl">
      <div className="w-[628px] md:w-full">
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040]">
          <div className="h-[56px] bg-[#D9D9D9] border-b-2 rounded-t-xl border-b-solid border-b-[#8C8C8C] grid grid-cols-9">
            <div className="flex justify-center items-center">
              <CheckBox
                id="terms"
                type="heading"
                onChecked={(e) => {
                  const data = advancedElectroMuscularData?.map((item) => {
                    return {
                      ...item,
                      isChecked: e,
                    };
                  });
                  setAdvancedElectroMuscularData(data);
                }}
                isChecked={advancedElectroMuscularData?.every(
                  (item) => item?.isChecked
                )}
              />
            </div>
            <div className="col-span-2 flex items-center">
              <p className="font-font-Titillium font-bold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase">
                Focus Area
              </p>
            </div>
            <div className="col-span-2 flex items-center justify-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                Duration
              </p>
            </div>
            <div className="col-span-2 flex items-center justify-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                Frequency
              </p>
            </div>
            <div className="col-span-2 flex items-center justify-center">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-center">
                Price
              </p>
            </div>
          </div>
          {advancedElectroMuscularData?.map((item, index) => (
            <div className="h-[56px] border-b border-b-solid border-b-[#D9D9D9] grid grid-cols-9">
              <div className="flex justify-center items-center">
                <CheckBox
                  id="terms"
                  onChecked={(e) => {
                    const data = advancedElectroMuscularData?.map((item, i) => {
                      if (i !== index) return item;
                      return {
                        ...item,
                        isChecked: e,
                      };
                    });
                    setAdvancedElectroMuscularData(data);
                  }}
                  isChecked={advancedElectroMuscularData[index]?.isChecked}
                />
              </div>
              <div className="col-span-2 flex items-center">
                <p className="font-font-Titillium font-bold text-[16px] leading-[19.2px] tracking-[0.0156em]">
                  {item?.focusArea}
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  {item?.duration}
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  <form>
                    <div class="grids grid-cols-12 justify-center">
                      <input
                        id="yellow-radio"
                        type="radio"
                        value="once"
                        name="colored-radio"
                        class="w-4 h-4 text-[#FAAD14] bg-gray-100 border-gray-300 focus:ring-[#FAAD14] focus:ring-0"
                        checked={
                          item?.frequency?.includes("once") ? true : false
                        }
                        onChange={(e) => {
                          const data = advancedElectroMuscularData?.map(
                            (item, i) => {
                              if (i !== index) return item;
                              return {
                                ...item,
                                frequency: e?.target?.value,
                                price: item?.price / 2,
                              };
                            }
                          );
                          setAdvancedElectroMuscularData(data);
                        }}
                      />
                      <label
                        for="yellow-radio"
                        class="ml-2 text-sm font-medium text-gray-900 "
                      >
                        Once a week
                      </label>
                    </div>
                    <div class="grids grid-cols-12 justify-center">
                      <input
                        id="yellow-radio"
                        type="radio"
                        value="twice"
                        name="colored-radio"
                        class="w-4 h-4 text-[#FAAD14] bg-gray-100 border-gray-300 focus:ring-[#FAAD14] focus:ring-0"
                        checked={
                          item?.frequency?.includes("twice") ? true : false
                        }
                        onChange={(e) => {
                          const data = advancedElectroMuscularData?.map(
                            (item, i) => {
                              if (i !== index) return item;
                              return {
                                ...item,
                                frequency: e?.target?.value,
                                price: item?.price * 2,
                              };
                            }
                          );
                          setAdvancedElectroMuscularData(data);
                        }}
                      />
                      <label
                        for="yellow-radio"
                        class="ml-2 text-sm font-medium text-gray-900 "
                      >
                        Twice a week
                      </label>
                    </div>
                  </form>
                </p>
              </div>
              <div className="col-span-2 flex items-center justify-center">
                <p className="font-font-Titillium font-normal text-[14px] leading-[16.8px] tracking-[0.0156em] text-center">
                  £{item?.price}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 h-[56px] grid grid-cols-8">
          <div className="col-span-[200px]"></div>
          <div className="col-span-5 flex items-center">
            <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-[#141414]">
              Total Charge:
            </p>
          </div>
          <div className="col-span-2 flex items-center justify-center ">
            <div className="rounded-xl bg-[#F5F5F5] w-[120px] h-[40px] flex items-center justify-center ">
              <p className="font-font-Titillium font-semibold text-[18px] leading-[27px] tracking-[0.0313] text-center">
                £
                {advancedElectroMuscularData?.reduce(
                  (prev, curr) => (curr.isChecked ? prev + curr.price : prev),
                  0
                ) || 0}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedElectroMuscular;
